import { 
  FETCH_ASSOCIATES_DATA_REQUEST,
  FETCH_ASSOCIATES_DATA_SUCCESS,
  FETCH_ASSOCIATES_DATA_FAILURE
 } from "./studioAssociatesDataTypes"

const initialState = {
    loading: false,
    studioAssociatesStore: "",
    // selectedQuestionList: null,
    error: '',
    
  }
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case   FETCH_ASSOCIATES_DATA_REQUEST:
        return {
          ...state,
          loading: true
        }
      case FETCH_ASSOCIATES_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          studioAssociatesStore: action.payload,
          error: ''
        }
      case FETCH_ASSOCIATES_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          studioAssociatesStore: [],
          error: action.payload
        }
       
      default: return state
    }
  }
  
  export default reducer
  